/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var map = {
    'ch-': 'theme-icon-channel-minus channels',
    'ch+': 'theme-icon-channel-plus channels',
    prev: 'theme-icon-previous',
    rewind: 'theme-icon-rewind',
    playPause: 'theme-icon-pause',
    forward: 'theme-icon-forward',
    next: 'theme-icon-next'
};

module.exports = function ( $item, data ) {
    var $wrapper = document.createElement('div'),
        $buttonIcon = document.createElement('div');

    $item.innerHTML = '';


    $wrapper.className = 'button';
    $buttonIcon.className = 'theme-icon ' + ( map[data.icon] || '' );
    $wrapper.appendChild($buttonIcon);
    $item.appendChild($wrapper);
    $item.$icon = $buttonIcon;

    if ( this.$links ) {
        this.$links[data.icon] = $item;
    }

    if ( !data.disable ) {
        this.enabledCount++;
    }

    $item.data = data;
};
